import { Directive, ElementRef, Input, OnChanges, Renderer2, SecurityContext, SimpleChanges } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { DomSanitizer } from '@angular/platform-browser';

/**
 * Felhasználói profilkép betöltése auth-fejléccel (a users/images/:file
 * végpontról blobként). A [appFetchUserImage] a kép fájlnevét kapja; ha üres
 * vagy a lekérés hibázik, a hosztelem eredeti tartalma (pl. iniciálék) marad.
 */
@Directive({
  selector: '[appFetchUserImage]'
})
export class FetchUserImageDirective implements OnChanges {
  @Input() appFetchUserImage: string | null = null;

  constructor(
    private el: ElementRef,
    private http: HttpClient,
    private sanitizer: DomSanitizer,
    private renderer: Renderer2
  ) {}

  ngOnChanges(_changes: SimpleChanges): void {
    const fileName = this.appFetchUserImage;
    if (typeof fileName === 'string' && fileName.trim().length > 0) {
      this.fetchImage(fileName);
    }
  }

  private fetchImage(imageFileName: string): void {
    this.http.get(`users/images/${imageFileName}`, { responseType: 'blob' }).subscribe((res: Blob) => {
      const url = this.sanitizer.sanitize(SecurityContext.URL, this.sanitizer.bypassSecurityTrustUrl(URL.createObjectURL(res)));
      if (url) {
        this.renderer.setAttribute(this.el.nativeElement, 'src', url);
        this.renderer.addClass(this.el.nativeElement, 'has-image');
      }
    });
  }
}
